module.exports = __webpack_public_path__ + "img/pic_location_TainanCity.636be15b.png";